import { ThemeMode } from "@amzn/stencil-react-components/context";
import IconPersonSmall from "@amzn/stencil-react-icons/icons/icon-person-small";
import IconSettingsSmall from "@amzn/stencil-react-icons/icons/icon-settings-small";
import React from "react";

import Selfie from "@/assets/icons/selfie.svg";
import SelfieDark from "@/assets/icons/selfie-dark.svg";
import Video from "@/assets/icons/video.svg";
import VideoDark from "@/assets/icons/video-dark.svg";
import { EntitlementCardProps } from "@/components/IdentityCheck/WizardPathChooser/IdentityVerificationSelectionCard";

const defaultEntitlementProps = {
  width: "407px",
};

export const getRivEntitlementAutomated = (
  themeMode: ThemeMode
): EntitlementCardProps => ({
  bodyi18nId: "identityCheck-pathchooser-card-ivv-body",
  bodyIcon: (
    <img
      src={themeMode === ThemeMode.Dark ? SelfieDark : Selfie}
      alt="Automated face scan icon"
    />
  ),
  dataTestId: "VerificationTypeCardAutomated",
  estimatedTimeToCompletionMinutes: 2,
  recommended: true,
  titlei18nId: "identityCheck-pathchooser-card-ivv-title",
  cardType: "IVV",
  verificationTypei18n:
    "identityCheck-pathchooser-card-verificationTypeAutomated",
  verificationTypeIcon: (
    <IconSettingsSmall color="color.link.primary-default" aria-hidden={true} />
  ),
  ...defaultEntitlementProps,
});

export const getRivEntitlementManual = (
  themeMode: ThemeMode
): EntitlementCardProps => ({
  bodyi18nId: "identityCheck-pathchooser-card-manual-body",
  bodyIcon: (
    <img
      src={themeMode === ThemeMode.Dark ? VideoDark : Video}
      alt="Record videos icon"
    />
  ),
  dataTestId: "VerificationTypeCardManual",
  estimatedTimeToCompletionMinutes: 15,
  titlei18nId: "identityCheck-pathchooser-card-manual-title",
  cardType: "ManualRIV",
  verificationTypei18n: "identityCheck-pathchooser-card-verificationTypeManual",
  verificationTypeIcon: (
    <IconPersonSmall color="color.text.primary" aria-hidden={true} />
  ),
  ...defaultEntitlementProps,
});

// Keep static exports for backward compatibility
export const RIV_ENTITLEMENT_AUTOMATED = getRivEntitlementAutomated(
  ThemeMode.Light
);
export const RIV_ENTITLEMENT_MANUAL = getRivEntitlementManual(ThemeMode.Light);
